import * as types from './actionTypes';

export function receiveAddress(address) {
	return { type: types.RECEIVE_ADDRESS, address: address };
}
